/* Bezpečný přístup k localStorage. Když prohlížeč zakáže data webu (nastavení
   soukromí, rozšíření, „mazat při zavření"), vyhodí SecurityError i pouhé ČTENÍ.
   Bez tohohle obalu na tom spadne celá aplikace hned při startu — a uživatel
   vidí černou obrazovku, protože ThemeProvider čte téma jako první věc. */
export const storage = {
  get(key, fallback = null) {
    try {
      const v = window.localStorage.getItem(key);
      return v === null ? fallback : v;
    } catch {
      return fallback;
    }
  },
  set(key, value) {
    try { window.localStorage.setItem(key, value); } catch { /* noop */ }
  },
  remove(key) {
    try { window.localStorage.removeItem(key); } catch { /* noop */ }
  },
};
